import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';
import { useIntl, FormattedMessage } from 'react-intl';
// material
import { Grid, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import BackDropLoader from '../../../components/BackDropLoader';
import { resetPassword } from '../services/authService';
import { useSnackbar } from 'notistack';
import { Stack } from '@mui/system';
// ----------------------------------------------------------------------

export default function ForgotPasswordForm({ onClose }) {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  const ForgotPasswordSchema = Yup.object().shape({
    email: Yup.string().email('common.form.email.requirements').required('common.form.email.required')
  });


  // eslint-disable-next-line no-unused-vars
  const handleResetPassword = async (values, actions) => {
    try {
      await resetPassword(values.email);
      enqueueSnackbar(<FormattedMessage id='forgotPassword.reset.msg.success' defaultMessage='New password sent to email' />, {
        variant: 'success',
      });
      onClose();
    } catch (error) {
      enqueueSnackbar(<FormattedMessage id='forgotPassword.reset.msg.error' defaultMessage='Failed to reset password' />, {
        variant: 'error',
      });
      actions.setSubmitting(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: ForgotPasswordSchema,
    onSubmit: handleResetPassword
  });

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps, dirty, isValid } = formik;

  return (
    <FormikProvider value={formik}>
      <BackDropLoader open={isSubmitting} />
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <TextField
            required
            fullWidth
            autoComplete="username"
            type="email"
            label={intl.formatMessage({
              id: 'user.form.label.emailAddress',
              defaultMessage: 'Email address'
            })}
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email ? <FormattedMessage id={formik.errors.email} defaultMessage={formik.errors.email} /> : ' '}
          />
          <Grid container justifyContent='flex-end'>
            <Grid item>
              <LoadingButton variant="contained" type="submit" loading={isSubmitting} disabled={!dirty || !isValid} >
                <FormattedMessage id={'forgotPassword.form.submit'} defaultMessage='Send mail' />
              </LoadingButton>
            </Grid>
          </Grid>
        </Stack>
      </Form>
    </FormikProvider>
  );
}

ForgotPasswordForm.propTypes = {
  onClose: PropTypes.func.isRequired
};